module.exports = __webpack_public_path__ + "static/media/upgrad-01.6f561d98.jpg";